import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { changeItemOwner } from '../itemOwner/itemOwnersSlice';

import { API } from '../../services/api';
const api = new API();

export const fetchWheels = createAsyncThunk(
  'wheels/get',
  async (data, thunkAPI) => {
    try {
      const response = await api.getWheels(data.ownerId);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: wheels/get', e.message);

      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

const initialState = {
  wheels: [],
  status: 'idle',
  error: null,
};

export const wheelsSlice = createSlice({
  name: 'wheels',
  initialState,
  reducers: {
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchWheels.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.error = null;
      state.wheels = action.payload.rims || []; // Rims term still in backend, rims === wheels
    },
    [fetchWheels.pending]: (state, action) => {
      state.status = 'loading',
      state.error = null;
    },
    [fetchWheels.rejected]: (state, action) => {
      state.status = 'failed';

      if(action.payload.code === 404) {
        state.error = {
          message: 'API_ENDPOINT_NOT_FOUND',
        };
      } else {
        state.error = {
          message: action.payload.messages.join(', ')
        };
      }
    },

    [changeItemOwner.fulfilled]: (state, action) => {
      // Clear state if owner changes
      return initialState;
    },
  }
});

export const selectWheels = state => state.wheels;

export default wheelsSlice.reducer;
